import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { Notify } from 'notiflix';
import { ApiService } from 'src/app/core/services/api.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
  public newsletterForm: any;
  public submitted: Boolean = false;
  constructor(
    private _apis: ApiService,
    private _formBuilder: UntypedFormBuilder,
  ) {
    this.newsletterForm = this._formBuilder.group({
      email: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(255), Validators.email]],
    });
  }

  ngOnInit(): void {
  }

  get f() { return this.newsletterForm.controls; }

  onSubmit() {
    this.submitted = true;
    if (this.newsletterForm.invalid) {
      if (this.f.email.errors.required) {
        Notify.failure('Email is required!');
      } else if (this.f.email.errors.minlength) {
        Notify.failure('Email should be atleast 3 characters!');
      } else if (this.f.email.errors.maxlength) {
        Notify.failure('Email should be atmost 250 characters!');
      } else if (this.f.email.errors.email) {
        Notify.failure('Please input a valid email!');
      }
      return;
    }

    this._apis.newsletter(this.newsletterForm.value).subscribe(
      res => {
        Notify.success('You have subscribed to newsletter!');
      },
      err => {
        // TODO
        console.log(err);
      }
    );
  }
}
